import { render, staticRenderFns } from "./waitDealReissueArrangement.vue?vue&type=template&id=385b9acc&scoped=true&"
import script from "./waitDealReissueArrangement.vue?vue&type=script&lang=js&"
export * from "./waitDealReissueArrangement.vue?vue&type=script&lang=js&"
import style0 from "./waitDealReissueArrangement.vue?vue&type=style&index=0&id=385b9acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385b9acc",
  null
  
)

export default component.exports